import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// 🔒 Sesión en sessionStorage: al cerrar la pestaña/navegador la sesión termina y NO se auto-reanuda.
const store = () => window.sessionStorage;

export const authService = {
  login: async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    store().setItem('token', response.data.access_token);
    store().setItem('user', JSON.stringify(response.data.user));
    return response.data;
  },

  register: async (email, password, full_name, role_id) => {
    const response = await axios.post(`${API}/auth/register`, {
      email,
      password,
      full_name,
      role_id
    });
    return response.data;
  },

  logout: () => {
    const token = store().getItem('token');
    store().removeItem('token');
    store().removeItem('user');
    // Invalida la sesión en el servidor (best-effort) para que los tokens/enlaces anteriores dejen de servir
    if (token) {
      axios.post(`${API}/auth/logout`, {}, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    }
  },

  getToken: () => store().getItem('token'),

  getUser: () => {
    const user = store().getItem('user');
    return user ? JSON.parse(user) : null;
  },

  setUser: (user) => {
    store().setItem('user', JSON.stringify(user));
  },

  setToken: (token) => {
    store().setItem('token', token);
  },

  isAuthenticated: () => {
    return !!store().getItem('token');
  },

  getAuthHeaders: () => {
    const token = authService.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }
};
